require('./helpers/bundle-manifest').register(JSON.parse("{\"2VAUp\":\"favorite.ff5b1bb6.js\",\"84BDf\":\"not-found.5e5584a2.png\"}"));